import { useState } from "react";
import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import Button from "./Components/Button";
import WithdrawInfoCard from "./Components/WithdrawInfoCard";
import Withdraw from "./Components/Withdraw";

export default function InviteFriends() {
  const [canPayout, setCanPayout] = useState(false);
  return (
    <LayoutPage
      activeIndex={8}
      navItems={["دعوت از دوستان"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["دعوت از دوستان", "برداشت جایزه"]}
        hrefs={["/invite", "/invite/gift"]}
        activeIndex={1}
      />
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        {canPayout && <Button />}
        <WithdrawInfoCard setCanPayout={setCanPayout} />
        <Withdraw />
      </div>
    </LayoutPage>
  );
}
